import { apiClient } from '../../gateways/api'
import type { AanvraagSearchResult } from '../types/AanvraagSearchResult'
import type { FetchAanvraag } from '../types/FetchAanvraag'

export { fetchAanvraag, initialState }

const fetchAanvraag = async ({
  aanvraagID,
}: {
  aanvraagID: string
}): Promise<AanvraagSearchResult> => {
  const { data } = await apiClient({
    url: `/rest/beheer/aanvraag/${aanvraagID}`,
    method: 'GET',
  })

  return data
}

const initialState: FetchAanvraag = {
  data: {},
}
